import React from 'react';

import { App } from '@meronex/app';

// App.settings is picked from the public/domains
// which would allow customization per domain
export const login = {
  backgroundImg: App.settings.login.backgroundImg,
  backgroundColor: '#00000087',
  color: 'white',
  logo: {
    src: App.settings.login.logo.src,
    style: App.settings.login.logo.style,
  },
};
